<template>
  <div>
    <div class="ibox animated fadeInRightBig">
      <div class="ibox-title">
        <h3>
          {{ (operation === "post" ? "Novo" : "Editar") + " " + modelName }}
          <i
            :class="'fa ' + icon"
            style="float: right; font-size: 21px; margin-top: -5px"
          ></i>
        </h3>
      </div>
      <form id="form">
        <div class="ibox-content">
          <div class="row">
            <div class="form-group col-md-12" v-if="model.photo">
              <div class="text-center m-b-lg">
                <img
                  :src="model.photo"
                  style="max-width: 240px; max-height: 340px"
                />
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="title"><span class="required">*</span> Título</label>
              <input
                type="text"
                class="form-control"
                name="title"
                v-model="model.title"
                id="title"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="theme_category_id"
                ><span class="required">*</span> Categoria de Tema</label
              >
              <select
                class="form-control"
                v-model="model.theme_category_id"
                id="theme_category_id"
              >
                <option value="" disabled selected>Selecione...</option>
                <option
                  :value="category.id"
                  v-for="(category, index) in themeCategories"
                  :key="index"
                >
                  {{ category.description }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="team_id"
                > Áreas de aplicação</label
              >
              <v-select 
              :options="teams"
              label="name"
              v-model="selectedTeams"
              multiple
              ></v-select>            
            </div>
            <div class="form-group col-md-12">
              <label for="summary"><span class="required"></span> Resumo</label>
              <vue-editor
              name="summary"
              id="summary"
              v-model="model.summary"
              />
            </div>

            <div class="col-md-12">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="photo"
                    ><span v-if="id == ''" class="required"></span>
                    Foto:</label
                  >

                  <div v-if="model.photo && !imgUrl">
                    <a
                      :href="model.photo"
                      data-toggle="tooltip"
                      target="_blank"
                    >
                      <img :src="model.photo" class="col-md-12 pictureSize" />
                    </a>
                  </div>

                  <div v-if="imgUrl">
                    <img :src="imgUrl" class="col-md-12 pictureSize" />
                  </div>

                  <input
                    type="file"
                    name="photo"
                    v-on:change="fileChanged"
                    id="photo"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="document"
                    ><span v-if="id == ''"></span>
                    Documento:</label
                  >
                  <label v-if="model.document"
                    >(clique na imagem para abrir)</label
                  >

                  <div v-show="model.document && model.id">
                    <a
                      :href="model.document"
                      data-toggle="tooltip"
                      target="_blank"
                    >
                      <img :src="pdfUrl" class="col-md-12 pictureSize" />
                    </a>
                  </div>
                  <div v-show="model.document && !model.id">
                    <img :src="pdfUrl" class="col-md-12 pictureSize" />
                  </div>

                  <input
                    type="file"
                    name="document"
                    id="document"
                    v-on:change="onDocumentChange"
                    accept="application/pdf"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="question"> Perguntas:</label>
                  <div v-show="model.question && model.id">
                    <a
                      :href="model.question"
                      data-toggle="tooltip"
                      target="_blank"
                    >
                      <img :src="pdfUrl" class="col-md-12 pictureSize" />
                    </a>
                  </div>
                  <div v-show="model.question && !model.id">
                    <img :src="pdfUrl" class="col-md-12 pictureSize" />
                  </div>

                  <input
                    type="file"
                    name="question"
                    id="question"
                    accept="application/pdf"
                    class="form-control"
                    v-on:change="onQuestionChange"
                  />
                </div>
                <div class="form-group col-md-6 m-t-sm">
                  <input type="checkbox" v-model="model.special" id="special" />
                  <label for="special">Evento Especial</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="pull-right">
            <router-link :to="backUrl" class="btn btn-info">
              <i class="fa fa-arrow-left"></i> Voltar
            </router-link>
            <a class="btn btn-success" @click="save">
              Salvar <i class="fa fa-save"></i>
            </a>
          </div>
          <p><span class="required">*</span> Campos Obrigatórios</p>
          <div class="clearfix"></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      selectedTeams: [],
      teams: [],
      model: {
        title: "",
        summary: "",
        photo: "",
        document: "",
        theme_category_id: "",
        special: "",
        question: "",
      },
      pdfUrl: this.$store.state.url + "img/defaults/pdf.png",
      imgUrl: null,
      themeCategories: [],
    };
  },
  props: {
    modelName: String,
    saveUrl: String,
    operation: String,
    id: String,
    backUrl: String,
    icon: String,
  },
  methods: {
    fileChanged: function (e) {
      const file = e.target.files[0];
      if (!file) this.imgUrl = null;
      else this.imgUrl = URL.createObjectURL(file);
    },
    save: function () {
      const self = this;
      const api = self.$store.state.api + self.saveUrl + self.id;

      let form = new FormData();
      let photo = document.getElementById("photo");
      let documentFile = document.getElementById("document");
      let questionFile = document.getElementById("question");

      form.append("title", self.model.title);
      form.append("summary", self.model.summary);
      form.append("theme_category_id", self.model.theme_category_id);
      form.append("photo", photo.files[0] ? photo.files[0] : "");
      form.append(
        "document",
        documentFile.files[0] ? documentFile.files[0] : ""
      );
      form.append(
        "question",
        questionFile.files[0] ? questionFile.files[0] : ""
      );
      form.append("special", self.model.special ? 1 : 0);
      
      self.selectedTeams.forEach( function(team) {
        form.append("selectedTeams[]", team.id)
      });

      if (self.id) {
        form.append("_method", "PUT");
        if(!self.model.document && !self.model.summary){
          self.$message(
            null,
            "O Tema precisa ter pelo menos um resumo OU um documento",
            "error"
          );
          return
        }
      }

      self.$http[self.$props.operation](api, form)
        .then((response) => {
          self.$message(
            null,
            `${self.modelName} ${
              !self.id ? "cadastrado" : "atualizado"
            } com sucesso!`,
            "success"
          );
          self.$router.push(self.backUrl);
        })
        .catch((error) => {
          self.$error(error);
        });
    },
    getModel() {
      const self = this;
      const api = self.$store.state.api + self.saveUrl + self.id + '?with[]=teams';

      self.$http
        .get(api)
        .then((response) => {
          self.model = response.data.data[0];
          if(self.model.summary == "<p>null</p>" || self.model.summary == "null"){
            self.model.summary = ''
          }
          self.selectedTeams = self.model.teams;
        })
        .catch((error) => {
          self.$message(
            null,
            "Ocorreu um erro ao buscar as informações",
            "error"
          );
        });
    },
    getThemeCategories() {
      const self = this;
      const api =
        self.$store.state.api +
        "theme-categories?paginated=false&orderByAsc=description";

      self.$http
        .get(api)
        .then((response) => {
          self.themeCategories = response.data.data;
        })
        .then(() => {
          if (self.id) {
            // Só pode carregar a model principal, após o combobox de categoria estar preenchido
            self.getModel();
          }
        })
        .catch((error) => {
          self.$message(
            null,
            "Ocorreu um erro ao buscar as informações",
            "error"
          );
        });
    },
    getTeams() {
      const self = this;
      const api =
      self.$store.state.api + "teams?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.teams = response.data.data;
        })
        .catch((error) => {
          self.$message(
            null,
            "Ocorreu um erro ao buscar as informações",
            "error"
          );
        });
    },
    onDocumentChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        if (!this.model.id) this.model.document = null;
        return;
      }
      this.document = files[0];
      this.model.document = files[0];
    },
    onQuestionChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        if (!this.model.id) this.model.question = null;
        return;
      }
      this.model.question = files[0];
    },
  },
  components: {
    VueEditor
  },
  mounted() {
    this.getTeams();
    this.getThemeCategories();
  },
};
</script>

<style scoped>
.pictureSize {
  max-width: 85px;
  max-height: 112px;
}
</style>



// WEBPACK FOOTER //
// src/components/Theme/FormSave.vue